module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (225).5881cfba.jpg";